

const FieldStatus = ({ valid = false, incrementor = 0 }) => {
    return valid ? <div className="checkmark draw"></div> : <div className="crossmark draw"></div>
}

export default FieldStatus;